import * as Select from '@radix-ui/react-select';
import { Check, ChevronDown, Plus, Trash } from 'lucide-react';
import React, { useState } from 'react';
import { createList, deleteList } from '../utils/contentService';


interface SelectListaCustomProps {
  listas: string[];
  selecionada: string;
  onChange: (nova: string) => void;
  onListasAtualizadas?: () => void;
  label?: string;
}

const SelectListaCustom: React.FC<SelectListaCustomProps> = ({
  listas,
  selecionada,
  onChange,
  onListasAtualizadas,
  label = 'Salvar em:'
}) => {
  const [novaLista, setNovaLista] = useState('');

  const handleCriarLista = () => {
    if (!novaLista.trim()) return;

    const criada = createList(novaLista.trim());
    if (criada && onListasAtualizadas) {
      onListasAtualizadas();
      onChange(novaLista.trim());
      setNovaLista('');
    }
  };

  const handleRemoverLista = () => {
    if (!novaLista.trim()) return;

    const confirmacao = confirm(`Deseja realmente remover a playlist "${novaLista}"?`);
    if (confirmacao) {
      const removida = deleteList(novaLista.trim());
      if (removida && onListasAtualizadas) {
        onListasAtualizadas();
        if (selecionada === novaLista.trim()) {
          onChange('Meus Favoritos');  // ou outra ação padrão
        }
        setNovaLista('');
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleCriarLista();
    }
  };

  return (
    <div className="mb-4">
      <label className="block text-white/80 mb-2 text-sm">{label}</label>
      <Select.Root value={selecionada} onValueChange={onChange}>
        <Select.Trigger className="inline-flex items-center justify-between w-full bg-[#222] text-white px-4 py-2 rounded border border-[#52432f] focus:outline-none focus:ring-2 focus:ring-[#52432f]">
          <Select.Value />
          <Select.Icon className="ml-2">
            <ChevronDown size={16} />
          </Select.Icon>
        </Select.Trigger>

        <Select.Portal>
          <Select.Content className="bg-[#222] text-white rounded shadow-lg z-50 max-h-64 overflow-y-auto">
            <Select.Viewport className="p-1 space-y-1">
              {/* Listas existentes */}
              {listas.map((lista) => (
                <Select.Item
                  key={lista}
                  value={lista}
                  className="flex items-center justify-between px-4 py-2 text-sm cursor-pointer hover:bg-[#333] focus:bg-[#444] rounded"
                >
                  <Select.ItemText>{lista}</Select.ItemText>
                  {selecionada === lista && (
                    <Select.ItemIndicator>
                      <Check size={14} className="text-green-400 ml-2" />
                    </Select.ItemIndicator>
                  )}
                </Select.Item>
              ))}

              {/* Campo para criar ou remover lista */}
              <div className="border-t border-[#333] mt-1 pt-2 px-2">
                <div className="text-xs text-white/50 mb-1">Criar ou remover lista</div>
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    value={novaLista}
                    onChange={(e) => setNovaLista(e.target.value)}
                    onKeyDown={handleKeyDown}
                    className="w-full px-2 py-1 text-sm bg-[#111] text-white rounded border border-[#333] focus:outline-none"
                    placeholder="Nome da playlist"
                  />
                  <button
                    onClick={handleCriarLista}
                    className="text-green-400 hover:text-green-300"
                    title="Criar"
                  >
                    <Plus size={18} />
                  </button>
                  <button
                    onClick={handleRemoverLista}
                    className="text-red-400 hover:text-red-300"
                    title="Remover"
                  >
                    <Trash size={18} />
                  </button>
                </div>
              </div>
            </Select.Viewport>
          </Select.Content>
        </Select.Portal>
      </Select.Root>
    </div>
  );
};

export default SelectListaCustom;
